import { SearchFormConfig } from '@awaze/design-system.compositions.search-form'

export const addBoatsToDestinationList = (config: SearchFormConfig): void => {
  const hasBoats = config?.accommodationType?.options[0]?.options.findIndex(
    (element) => element.value === 'boat-holidays',
  )

  if (hasBoats !== undefined) {
    config.accommodationType.options[0].options[hasBoats] = {
      ...config.accommodationType.options[0].options[hasBoats],
      destinationListParentID: 'boats',
      rhsHeaders: {
        rhs1: 'Choose boats region',
        rhs2: 'Choose boats area',
      },
    }
  }
}
